import { Controller, useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'
import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CurrencySelector from 'modules/finance/components/CurrencySelector'

import { castError } from '../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../withFieldPermissions'

const FIELD_NAME = 'currency'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  isAutomaticExpensable?: boolean
}

const CurrencyField = ({ currencies, isAutomaticExpensable = false, isFieldReadOnly }: Props) => {
  const {
    watch,
    control,
    formState: { errors },
  } = useFormContext()

  const documentType = watch('documentType')
  const label =
    documentType === 'invoice'
      ? i18n.t('expenses_v2.forms.fields.document_currency.label_invoice')
      : documentType === 'receipt'
      ? i18n.t('expenses_v2.forms.fields.document_currency.label_receipt')
      : i18n.t('expenses_v2.forms.fields.document_currency.label')

  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Box width="full">
      <Controller
        name={FIELD_NAME}
        control={control}
        render={({ field }) => (
          <CurrencySelector
            label={label}
            currencies={currencies}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            isDisabled={isReadOnly}
            error={castError(errors?.currency)}
          />
        )}
      />
    </Box>
  )
}

export default withCustomizationFields(withFieldPermissions(CurrencyField, FIELD_NAME))
